import React from 'react'
import './App.css'
// import 'bootstrap/dist/css/bootstrap.css'
import RouterPage from './components/common/router'

function App() {
  return <RouterPage />
}

export default App
